// extracted by mini-css-extract-plugin
export default {"background":"ModalLayout_background__aogHJ","modal":"ModalLayout_modal__g-+6M","content":"ModalLayout_content__mTJoy","close":"ModalLayout_close__qLtnj"};